// VTK type definitions for ROM model visualization

export type VtkCellsInfo = {
  connectivity: number[][];
  types?: number[];
};

export type VtkDataArray = {
  name: string;
  numberOfComponents: number;
  size: number;
  values: number[] | number[][];
};

export interface BackendPolyDataResponse {
  message: string;
  time_ROM: number;
  BC_ROM: number;
  field: string;
  cells: VtkCellsInfo;
  points: number[][];
  point_data: Record<string, VtkDataArray>;
  activeScalar?: string;
}

export type FieldOption = 'agem1' | 'agem2' | 'washout';

export const FIELD_OPTIONS: { value: FieldOption; label: string }[] = [
  { value: 'agem1', label: 'Age M1 [s]' },
  { value: 'agem2', label: 'Age M2 [s²]' },
  { value: 'washout', label: 'Washout' },
];

export function getFieldLabel(field: FieldOption): string {
  return FIELD_OPTIONS.find((opt) => opt.value === field)?.label || field;
}
